export const buttonNormal = '#233b69';
export const buttonHover = '#0070ba';
export const buttonSelected = '#233b69';
export const buttonDisabled = '#ebebeb';

export const themeColors = {
  backgroundLightBlue: process.env.APP_NAME === 'TRIPLEMARS' ? '#edf4fc' : '#fff1f0',
  backgroundDarkBlue: process.env.APP_NAME === 'TRIPLEMARS' ? '#e4edf7' : '#ffa39e',
  backgroundLightGray: '#f4f6fa',
  backgroundDarkGray: process.env.APP_NAME === 'TRIPLEMARS' ? '#fafbfe' : '#fefafa',
  blue: '#0070ba',
  darkBlue: '#233b69',
  darkBlueFont: '#ffffff',
  lightBlue: '#d9e7ff',
  eggplantBlue: '#3f435c',
  dirtyBlue: '#586784',
  dirtyLightBlue: '#a2adc4',
  purple: '#474588',
  brightPurple: '#6f6dc3',
  mustard: '#ffdb58',
  beige: '#ebebeb',
  green: '#08ac08',
  pink: '#ff3f71',
  grey: '#c6d1df',
  lightGrey: '#e8ecf2',
  shadowDarkBlue: '#0069fa26',
  warning: '#ffe6d9',
  warningFont: '#ff5700',
  info: '#02aff9',
  infoFont: '#0070ba',
  success: '#d9fcd9',
  successFont: '#08ac08',
  red: '#ff0000',
  turquoise: '#40e0d0',
};
